module.exports = __webpack_public_path__ + "static/media/nike-never-ask-zobnin.28bad350.mp4";